/* eslint-disable react/prop-types */
// @flow

// Standard Pakete
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import { hot } from 'react-hot-loader'

// hinzugefügte Pakete
import { Masthead } from '@ta-interaktiv/react-masthead'
import Cover from '../cover'
import { FeedbackMessage } from '@ta-interaktiv/react-feedback-message'
import { UserFeedback } from '@ta-interaktiv/react-user-feedback'
import { Waypoint } from 'react-waypoint'
import Chart from '../../components/chart'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { VideoPlayer } from 'components/videoplayer'
import { Footer } from '@ta-interaktiv/react-footer'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'

// CSS
import 'styles/App.css'
import './style.scss'

const ARTICLE_ID = '29547550'
let teaserIds = ['25894570', '17336346', '10577998']
let baseUrl = window.location.hostname.replace('interaktiv.', '')
baseUrl = baseUrl.replace('.ch', '')
baseUrl.replace(new RegExp('.', 'g'), '')
const isMobile = window.innerWidth < 600
const ADDITIONAL_SHARES = 593

class AppComponent extends React.Component<Props> {
  constructor(props) {
    super(props)
    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)
    this.longText = []
  }

  trackNavClicks(e) {
    let clickedText = e.currentTarget.firstChild.nodeValue
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'question: ' + clickedText
    })
  }

  trackTopClicks(e) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: '
    })
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead
          inverted
          articleId={ARTICLE_ID}
          additionalShares={ADDITIONAL_SHARES}
        />
        <header className='ui vertical fitted segment first'>
          <Cover
            title='«Ich würde dich gerne von oben bis unten abschlecken»'
            subtitle='Wie vier Journalistinnen sexuelle Belästigung erlebt haben.'
          />
        </header>
        <div className='ui container'>
          <div className='ta secondary caption'>
            {' '}
            Sie erzählen von ihren Erlebnissen: Jana Avanzini, Ines Rütten,
            Theresa Beyer und Samantha Zaugg (v.l.n.r.). Fotos: Philipp Rohner
          </div>
        </div>

        <div className='ui vertical fitted segment white background'>
          <div className='ui text container'>
            <p className='ta author' style={{ paddingTop: '2em' }}>
              Simone Rau, Oliver Zihlmann und Mathias Born
            </p>
            <p>
              Im Umgang mit Vorgesetzten und Arbeitskollegen erleben
              Journalistinnen laufend sexuelle Belästigungen. Es passiert im
              Büro, bei Dreharbeiten, an Firmenfesten, in der Kantine. Das zeigt
              eine anonyme Umfrage des Recherchedesks und des Datenteams von
              Tamedia. Besonders gefährdet sind unerfahrene
              Berufseinsteigerinnen. Als Belästiger nennen die
              Umfrage-Teilnehmerinnen auffallend häufig ihre Vorgesetzten. Die
              Hälfte der Betroffenen erlebt mehr als nur schlüpfrige Sprüche,
              und viele leiden jahrelang, während die Beschuldigten kaum je
              belangt werden. Das liegt vor allem daran, dass nur ganz wenige
              Belästigte die Vorfälle melden.
            </p>

            <p>
              Verstärkt werden die Probleme am Arbeitsplatz durch Belästigungen,
              die Journalistinnen ausserhalb ihres eigentlichen Büros erleben.
              Zum Beispiel bei Interviews mit Politikern, Managern oder
              Musikern, auf Reportage-Reisen oder an Treffen mit Informanten.
              Auch hier sind sie körperlichen Übergriffen bis hin zu sexuellen
              Nötigungen ausgesetzt, auch hier werden Gegenleistungen von ihnen
              verlangt, für ein Interview zum Beispiel. Dazu kommen Fälle von –
              zum Teil massivem – Stalking durch Hörer, Zuschauer und Leser.
            </p>

            <p>
              Doch wie fühlt es sich an, selbst von sexueller Belästigung
              betroffen zu sein?
            </p>
          </div>

          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '25ContentRead'
                })
              }
            }}
          />

          {/* Videos */}

          <div className='ui text container'>
            <VideoPlayer
              mp4={require('./videos/jana_avanzini.mp4')}
              mp4Mobile={require('./videos/jana_avanzini_mobile.mp4')}
              webm={require('./videos/jana_avanzini.webm')}
              webmMobile={require('./videos/jana_avanzini_mobile.webm')}
              poster={require('./videos/jana_avanzini.jpg')}
              trackingID='01 - Jana Avanzini'
            />
          </div>
          <div className='ui text container'>
            <h3 className='quote'>
              «Er griff mir an den Po. <br className='mobile hidden' />
              Es war einfach nur eklig»
            </h3>
            <hr className='quote-divider' />
            <div className='quote label'>
              <span className='quote label'>
                Jana Avanzini, freie Journalistin
              </span>
            </div>
          </div>
          <div className='ui text container'>
            <Chart
              trackingID='01 - Jana Avanzini'
              shortText='<p>Jana Avanzini, 32 Jahre alt und freie Journalistin, nennt ihn den «Glüschteler». Sie wollte ihn eigentlich für einen Artikel befragen. Doch was ein professionelles Gespräch für ein Porträt hätte werden sollen, artete rasch aus. «Er deckte mich während des dreistündigen Treffens mit zahlreichen sexistischen Sprüchen ein. Was für eine Herzige ich doch sei. Ob er mich ausziehen dürfe. Dass er mich gerne von unten bis oben abschlecken würde. Er griff mir an den Po. Und er versuchte, mich zu küssen. Es war einfach nur eklig.»</p>'
            />
            <p>
              Musikjournalistin Theresa Beyer, seit 2013 bei Radio SRF 2 Kultur
              angestellt, berichtet von einem Treffen mit einem Sänger im
              Backstage-Bereich eines Clubs. Mitten im Interview – das
              Aufnahmegerät läuft, das Gespräch ist interessant – legt er seine
              Hand auf ihren Arm: «Was für eine schöne Bluse du trägst», sagt er
              und streichelt Beyers Arm. Von dort greift seine Hand an ihr Knie.
              Und streichelt auch dieses. «Ich sagte ihm, dass ich gerne mit
              meinen Fragen weiterfahren will», erinnert sich die heute
              32-Jährige. «Das war eine körperliche Grenzüberschreitung und
              respektlos gegenüber meiner Arbeit.»
            </p>
            <p>
              Jana Avanzini und Theresa Beyer gehören zu den 244
              Journalistinnen, die in einer Online-Umfrage der Redaktion Tamedia
              von ihren Erfahrungen mit sexuellen Belästigungen und Übergriffen
              bei der Arbeit berichten. Die Umfrage ist nicht repräsentativ,
              doch der sehr grosse Umfang der Rückmeldungen verleiht den
              Ergebnissen Gewicht. Die Journalistinnen aus Print, Fernsehen,
              Radio und Online schildern auf Hunderten Seiten teilweise
              ausführlich und im Detail erschütternde Erlebnisse. 204 Frauen
              machen Angaben darüber, wer hinter den Belästigungen steckt. 40
              Prozent von ihnen nennen als Urheber nicht Kollegen oder
              Vorgesetzte, wie das sonst üblich ist bei Belästigungen am
              Arbeitsplatz. Sondern externe Personen, mit denen sie in ihrem
              Beruf täglich zu tun haben: Politiker, Manager, Musiker, Sportler,
              Informanten oder Experten. Aber auch Zuschauer, Hörer und Leser.
            </p>
            <a href={'https://www.' + baseUrl + '.ch/schweiz/mediatoo/'}>
              <img
                src={require('./imgs/inline-teaser.jpg')}
                className='ui fluid image'
                style={{ paddingBottom: '1em' }}
              />
            </a>
            <p>
              Die Tamedia-Umfrage war anonym, doch die Teilnehmerinnen und
              Teilnehmer konnten, wenn sie wollten, ihre Kontaktdaten
              hinterlassen. Musikjournalistin Beyer wollte. «Ich möchte
              stellvertretend für andere Journalistinnen schildern, wie ich in
              manchen Situationen von Männern daran gehindert wurde, meinen Job
              zu machen. Und dass es mitunter gefährlich werden kann.» So habe
              ein Musiker bei einem Interview in einem Hotelzimmer einmal die
              Tür verriegelt, nachdem sie eingetreten sei – sie sei «extrem
              erschrocken». Seither führe sie trotz guter Akustik keine
              Interviews mehr in Hotelzimmern.
            </p>
            <p>
              Auch die freie Journalistin Jana Avanzini will ihre Geschichte
              erzählen. «Was mir passiert ist, darf nicht passieren», sagt sie.
              «Es braucht eine öffentliche Diskussion über sexuelle Belästigung.
              Deshalb stehe ich hier mit meinem Namen hin.»
            </p>
            <p>
              Die Umfrage gibt deutliche Hinweise darauf, dass für viele der
              Umgang mit Journalistinnen ein Problem ist. «Sie sind offenbar
              viel öfters Belästigungen durch Externe ausgesetzt als der
              Durchschnitt in unserer nationalen Studie», sagt Marianne Schär
              Moser, Mitverfasserin der ersten schweizweiten Studie zu sexueller
              Belästigung am Arbeitsplatz für das Staatssekretariat für
              Wirtschaft. Ähnlich hohe Werte erzielten nur die Pflegerinnen, die
              sich mittlerweile gezielt organisiert haben, um den Belästigungen
              durch Patienten vorzubeugen.
            </p>
            <Waypoint
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: '50ContentRead'
                  })
                }
              }}
            />
            <p>
              Für Journalistinnen gibt es hingegen keinen organisierten Schutz
              vor sexuellen Übergriffen durch Interviewpartner während der
              Arbeit. Dabei zeigen die Beispiele aus der Umfrage, wie wichtig
              das wäre.{' '}
            </p>
            <p>
              Eine Sportjournalistin aus der Romandie berichtet etwa von einem
              körperlichen Übergriff durch einen ausländischen Tennisspieler.
              Der Vorfall ereignete sich, als sie während eines Turniers im
              gleichen Hotel wie der Spieler wohnte: «Er spricht mich an, ich
              stehe vor seiner Tür. Wir reden über ein paar Banalitäten, das
              Turnier, das Wetter. Ich sage ihm ganz klar, dass ich Journalistin
              bin. Da drückt er mich plötzlich gegen die Wand und schiebt seine
              Zunge in meinen Mund. Ich stosse ihn zurück und versuche, ihn zur
              Vernunft zu bringen. Er will nichts hören, behauptet, ich wolle es
              auch, stösst mich aufs Bett. Ich schlage um mich und kann mich
              befreien. Er zieht seine Hose runter und zeigt mir, wie erregt er
              ist: ‹Schau, in welchen Zustand du mich gebracht hast. Küss ihn
              wenigstens, bevor du gehst.›»
            </p>
            <p>
              Die Journalistin berichtet, sie habe sich während mehrerer Tage
              schuldig gefühlt – obwohl sie nichts gemacht habe. «Er hat die
              Situation ausgenutzt in der Annahme, jede Frau sei ein Groupie und
              würde seinen Annäherungsversuchen nachgeben», schreibt sie über
              den Sportler, der seine Karriere mittlerweile beendet hat.
            </p>
            <p>
              Ähnliches sagt Theresa Beyer über ihren Vorfall mit dem Musiker.
              Gerade die Popmusikbranche sei «stark männlich dominiert». Für die
              Frauen sei traditionell die Rolle der Groupies vorgesehen; als
              kompetente Journalistin müsse man sich da zuerst einmal Respekt
              verschaffen. «Je berühmter die Männer sind, desto eher nutzen sie
              ihre Position aus, da sie auf die Berichterstattung nicht mehr
              angewiesen sind», so die Erfahrung der Radiojournalistin.
            </p>
            <p>
              In der Umfrage gibt es zahlreiche Beispiele dieser Art: Politiker,
              Manager oder Künstler ziehen die Journalistinnen, die sie
              interviewen wollen, auf den Schoss, fassen ihnen an Busen oder Po,
              machen klare sexuelle Avancen. Eine Printjournalistin, die für
              eine Recherche in Kontakt mit einem wichtigen Informanten stand,
              schreibt: «Eines Abends schrieb er, er sei jetzt bereit für ein
              Treffen. Auf die Frage, wo wir uns treffen sollen, lud er mich zu
              ihm nach Hause ein. Als ich schrieb, ich würde lieber an einem
              neutralen Ort mit ihm sprechen, schickte er mir ein Foto seines
              erigierten Penis mit dem Hinweis, ‹damit› könne er nicht aus dem
              Haus. Da habe ich den Kontakt abgebrochen.»
            </p>
          </div>

          <div className='ui text container'>
            <VideoPlayer
              mp4={require('./videos/ines_ruetten.mp4')}
              mp4Mobile={require('./videos/ines_ruetten_mobile.mp4')}
              webm={require('./videos/ines_ruetten.webm')}
              webmMobile={require('./videos/ines_ruetten_mobile.webm')}
              poster={require('./videos/ines_ruetten.jpg')}
              trackingID='02 - Ines Ruetten'
            />
          </div>
          <div className='ui text container'>
            <h3 className='quote'>
              «Bis heute überlege ich mir, <br className='mobile hidden' />
              wie ich hätte reagieren müssen»
            </h3>
            <hr className='quote-divider' />
            <div className='quote label'>
              <span className='quote label'>
                Ines Rütten, Journalistin «Landbote»
              </span>
            </div>
          </div>
          <div className='ui text container'>
            <Chart
              trackingID='02 - Ines Ruetten'
              shortText='<p>Das Problem sind nicht nur körperliche Übergriffe. Oft sind es auch deplatzierte sexuelle Sprüche mitten in einem Arbeitsgespräch, das eigentlich professionell ablaufen sollte. Ines Rütten, seit 2012 beim Winterthurer «Landboten» angestellt, erzählt anhand eines Beispiels, wie so ein Vorfall abläuft. Sie wollte einen Unternehmer für ein Interview treffen. Zunächst trifft sie dessen Geschäftspartner, den sie zufällig vom Reiten kennt. Dieser bietet Ines Rütten an, sie dem Unternehmer vorzustellen. Im Büro angekommen, sagt er: «Ich habe dir hier Ines Rütten gebracht, wir kennen uns vom Reiten.» Der Unternehmer, mit dem sie gleich ein Interview führen soll, sagt: «Ja, die würde ich auch gerne einmal reiten.»</p>'
            />
            <Waypoint
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: '75ContentRead'
                  })
                }
              }}
            />
            <p>
              Die Journalistin kann nicht glauben, was sie gerade gehört hat.
              Und bleibt doch stumm. «Danach spulte ich das Interview ab, als
              wäre nichts geschehen», erinnert sich die mittlerweile 34-Jährige.
              Das Problem an solchen Szenen: Der Sprücheklopfer sieht das
              womöglich als Lappalie. Die Betroffenen ärgern sich aber oft noch
              jahrelang darüber, dass sie mit sexuellen Bemerkungen herabgesetzt
              wurden. Das ging auch Ines Rütten so: «Bis heute überlege ich mir,
              wie ich hätte reagieren müssen. Und ich ärgere mich, dass ich das
              habe mit mir machen lassen.»
            </p>
            <p>
              «Wut» und «Ärger» sind die häufigsten Begriffe, mit denen die
              Journalistinnen in der Umfrage das Erlebte beschreiben. Sie
              verlangen, dass die Männer, denen sie professionell begegnen, sich
              ebenso professionell verhalten. Gerade bei jungen Journalistinnen,
              die noch wenig Erfahrung haben, ist das aber oft nicht der Fall.
            </p>

            <VideoPlayer
              mp4={require('./videos/samantha_zaugg.mp4')}
              mp4Mobile={require('./videos/samantha_zaugg_mobile.mp4')}
              webm={require('./videos/samantha_zaugg.webm')}
              webmMobile={require('./videos/samantha_zaugg_mobile.webm')}
              poster={require('./videos/samantha_zaugg.jpg')}
              trackingID='03 - Samantha Zaugg'
            />
          </div>
          <div className='ui text container'>
            <h3 className='quote'>
              «Vor einem Interview überlege ich mir ganz genau, was ich anziehe»
            </h3>
            <hr className='quote-divider' />
            <div className='quote label'>
              <span className='quote label'>
                Samantha Zaugg, Multimedia-Journalistin
              </span>
            </div>
          </div>
          <div className='ui text container'>
            <Chart
              trackingID='03 - Samantha Zaugg'
              shortText='<p>Die 24-jährige Multimedia-Journalistin Samantha Zaugg berichtet, wie sie in ihrer Zeit als junge Video-Journalistin für den Regionalfernsehsender Tele Top immer wieder von ihren männlichen Interviewpartnern mit zweideutigen Sprüchen eingedeckt wurde. Ein Experte, auf dessen Einschätzung sie dringend angewiesen war, versuchte bei jedem Treffen, sie über sehr persönliche Dinge auszufragen, gab ihr ungefragt Küsschen und versuchte, mit ihr zu flirten. Ein Politiker empfing sie um 10 Uhr morgens in Unterhosen und Bademantel. Vor einem anderen Termin sagte er ihr am Telefon: «Kommen Sie nicht zu früh, sonst bin ich noch in meinen Unterhosen, und das wollen Sie wahrscheinlich nicht sehen. Oder wollen Sie das doch sehen?» Ein gestandener männlicher Journalist würde kaum je so behandelt werden.</p>'
            />
            <p>
              «Im Lokaljournalismus trifft man die gleichen Menschen immer
              wieder, ist darauf angewiesen, dass sie mit einem sprechen», sagt
              Samantha Zaugg, die mit 19 Jahren bei Tele Top einstieg. «Als
              junge Journalistin wusste ich nicht, wie ich mit der Situation
              umgehen sollte.» Sie sei männlichen Interviewpartnern gegenüber
              heute «sehr reserviert» und überlege sich vorher «ganz genau», was
              sie anziehe. «Keine grellen Farben, keine Schminke, kein
              Lippenstift. Und das, obwohl ich mich gerne modisch kleide.
              Eigentlich unglaublich.»
            </p>
            <p>
              Sie hätten vergleichsweise nichts Schlimmes erlebt, sagen die vier
              Frauen. Auch deshalb wollten sie an die Öffentlichkeit treten.
              «Wenn wir nicht reden, wer dann?», sagt Ines Rütten. «Es genügt
              nicht, wenn nur wir Frauen untereinander darüber diskutieren, wie
              wir mit sexueller Belästigung umgehen sollen.»
            </p>
            <div
              className='ui text container infographic'
              style={{ marginBottom: '0.8em' }}
            >
              <FeedbackMessage
                question='Haben Sie Erfahrungen mit sexuellen Übergriffen oder Belästigungen im Arbeitsumfeld gemacht?'
                call='Bitte senden Sie eine Nachricht an '
                mailTo='simone.rau@tamedia.ch'
              />
            </div>
            <p>
              Sie sprechen auch für andere, die sich ebenfalls mit Namen äussern
              wollten, um von ihren Fällen zu berichten – dann aber im letzten
              Moment davor zurückschreckten. Zum Beispiel eine
              Radiojournalistin, die knapp zwei Monate lang täglich Gedichte mit
              massiven Vergewaltigungsfantasien von einem Hörer erhielt. «Er
              beschrieb unter anderem, wie er mich mit einer Eisenstange
              vergewaltigen würde», sagt sie am Telefon. Sie hat sich auf die
              Umfrage mit Namen gemeldet, wollte dann aber doch anonym bleiben.
              «Es wäre wichtig, dass ich mit meinem Gesicht hinstehe und mich
              auch fotografieren lasse. Aber ich schaffe es nicht.» Der Stalker
              sei damals aus dem Nichts aufgetaucht, genauso wie ein zweiter
              Stalker, der plötzlich leibhaftig vor ihr gestanden sei. Sie wolle
              deshalb kein Risiko eingehen.
            </p>
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          additionalShares={ADDITIONAL_SHARES}
          hidePortfolioTeaser
          questions={[
            'Finden Sie diese Recherche relevant?',
            'Wie beurteilen Sie die Qualität der Videos?',
            'Ist die Gestaltung dieser Seite ansprechend?'
          ]}
          credits={[
            ['Text & Umfrage', `Simone Rau, Oliver Zihlmann, Mathias Born`],
            ['Videos', `Anja Stadelmann, Anthony Ackermann, Simone Rau`],
            ['Fotos', `Philipp Rohner`],
            ['Programmierung & Gestaltung', 'Mathias Lutz, Interaktiv-Team']
          ]}
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
            <ArticleTeasers
              sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
              numberOfCards='three'
              articleIds={teaserIds}
            />
          </div>
        </Footer>
      </div>
    )
  }
}

export default hot(module)(AppComponent)
